import { CustomerSegmentSchema } from '@kilat/shared';
import { createRepo } from './_base.js';

/**
 * Operator-defined customer segments — reusable, saved audience filters.
 *
 *   tenants/{tid}/customerSegments/{segmentId}
 *
 * Read+write by owner|manager (firestore.rules, mirrors customerTags). The
 * marketing broadcast composer targets a campaign at a saved segment
 * (`audience: { kind: 'segment', segmentId }`); the `runCampaignNow` dispatcher
 * resolves it server-side against the tenant customer index.
 */
export function customerSegmentsRepoFor(tenantId: string) {
  return createRepo({
    path: `tenants/${tenantId}/customerSegments`,
    schema: CustomerSegmentSchema,
    name: `tenants/${tenantId}/customerSegments`,
  });
}
